<template>
  <em-z-tree ref="bomTree" :treeNodes="bomTreeNodes" :chkboxType="chkboxType" textKeys="chineseName" checkEnable>
  </em-z-tree>
</template>
<script>
// Author YuJiaBei
// Date 2020-10-8 14:25:08

import EmZTree from "@/components/em/EmZTree";
import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "bomTree",
  mixins: [EmCommonApi],
  components: {EmZTree},
  data() {
    return {
      bomTreeNodes: [],
      chkboxType: {"Y": "s", "N": "s"} //父节点可以连带子节点，子节点不连带父节点
    }
  },
  methods: {
    getBomTreeNodes() {
      this.$_emApiMixin_findByFilter("sithMesMstBom", {})
                .then(data => {
                    this.bomTreeNodes = data
                })
    },
    getBomIds() {
      let bomNodes = this.$refs['bomTree'].getCheckedNodes()
      var v = "";
      for (var i = 0; i < bomNodes.length; i++) {
        v += "," + bomNodes[i].id
      }
      return v.length > 0 ? v.substring(1) : v;
    }
  },
  mounted() {
    this.getBomTreeNodes();
  }
};
</script>